import React, {useState, useEffect, useRef} from 'react';
import {Button, Card, Form, Row, Col, Alert, Spinner} from 'react-bootstrap';
import {fetchGetData, fetchPostData, fetchFormData} from './api'; // Import your common API file
import Fuse from 'fuse.js';
import { AgGridReact } from 'ag-grid-react';
import { ClientSideRowModelModule } from 'ag-grid-community';
import { ValidationModule } from 'ag-grid-community';




const TrackEmployee = () => {
    const [employerData, setEmployerData] = useState([]);

    //for updation
    const [isEditMode, setIsEditMode] = useState(false);
const [editEmployerId, setEditEmployerId] = useState(null);

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [companyGSTIN, setCompanyGSTIN] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [companyMobile, setCompanyMobile] = useState('');
    const [companyAddress, setCompanyAddress] = useState('');
    const [contactName, setContactName] = useState('');
    const [companyPincode, setCompanyPincode] = useState('');
    const [district, setDistrict] = useState('');
    const [selectedArea, setSelectedArea] = useState('');
    const [districts, setDistricts] = useState([]);
    const [jobEmployer, setEmployer] = useState([]);
    const [areas, setAreas] = useState([]);
    const [executive, setExecutive] = useState('');
    

    const handleFindMatch = (fuse, inputString) => {
        console.log("Input String:", inputString);

        // Perform the search using Fuse.js
        const result = fuse.search(inputString);

        // Log all search results with their scores
        result.forEach(item => {
            console.log(item.item.dist || item.item.area_name, item.score);  // Log the city name and its matching score
        });

        if (result.length > 0) {
            // const bestMatch = result[0].item.dist;
            const bestMatch = result[0].item.id;
            console.log(`Best match: ${bestMatch}`);
            return bestMatch;
        } else {
            console.log("No matches found.");
            return 0;
        }
    };


    const districtMap = districts.reduce((acc, d) => {
        acc[d.id] = d.dist;
        return acc;
    }, {});
    
    const areaMap = districts.flatMap(d => d.areas).reduce((acc, a) => {
        acc[a.id] = a.area_name;
        return acc;
    }, {});
    
    const executiveMap = jobEmployer.reduce((acc, e) => {
        acc[e.id] = e.name;
        return acc;
    }, {});
    

    const columnsStaffing = [
        { headerName: "S. No", valueGetter: (params) => params.node.rowIndex + 1, width: 80 },
           {
                    headerName: "Edit",
                    field: "edit",
                    cellRenderer: (params) => (
                        <Button
                            variant="primary"
                            size="sm"
                            onClick={() => handleEdit(params.data)}
                        >
                            ✏️ Edit
                        </Button>
                    ),
                    width: 100,
                },
        { headerName: 'GSTIN', field: 'gstin', flex: 2 },
        { headerName: 'Company Name', field: 'companyName', flex: 2 },
        { headerName: 'Mobile', field: 'mobile', flex: 2 },
        { headerName: 'Address', field: 'address', flex: 2 },
        { headerName: 'Contact Name', field: 'name', flex: 2 },
        { headerName: 'Pincode', field: 'pincode', flex: 2 },
        {
            headerName: 'District',
            field: 'district',
            flex: 2,
            valueFormatter: (params) => districtMap[params.value] || params.value
        },
        {
            headerName: 'City',
            field: 'city',
            flex: 2,
            valueFormatter: (params) => areaMap[params.value] || params.value
        },
        {
            headerName: 'Executive',
            field: 'executive',
            flex: 2,
            valueFormatter: (params) => executiveMap[params.value] || params.value
        },
        { headerName: 'Created At', field: 'createdAt', flex: 2 }
    ];
    

    const handleEdit = (employer) => {
        setEditEmployerId(employer._id); // Store MongoDB's _id for update
        setIsEditMode(true);             // Switch to edit mode
    
        // Populate form with existing values
        setCompanyGSTIN(employer.gstin || '');
        setCompanyName(employer.companyName || '');
        setCompanyMobile(employer.mobile || '');
        setCompanyAddress(employer.address || '');
        setContactName(employer.name || '');
        setCompanyPincode(employer.pincode || '');
        setDistrict(employer.district || '');
        setSelectedArea(employer.city || '');
        setExecutive(employer.executive || '');
    
        // Set areas based on district
        const selectedDistrict = districts.find(d => d.id === Number(employer.district));
        if (selectedDistrict) {
            setAreas(selectedDistrict.areas);
        }
    };

    
    
    // Fetch data on component mount
    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             const [districtRes, jobEmployer,employerData] = await Promise.all([ // jobRoleRes
    //                 fetchGetData('/master/get/district/city'), // Replace with actual API
    //                 // fetchGetData('/master/get/title'),    // Replace with actual API
    //                 fetchGetData('/master/get/executive'),    // Replace with actual API
    //                 fetchGetData('/employer/get/employer/all')    // Replace with actual API
    //             ]);
    //             setDistricts(districtRes.data);
    //             // setJobRoles(jobRoleRes.data);
    //             setEmployer(jobEmployer.data);
    //             setEmployerData(employerData.data);
    //         } catch (error) {
    //             console.error('Error fetching data:', error);
    //             setErrorMessage('Error loading district and job role data.');
    //         }
    //     };

    //     fetchData();
    // }, []);


    const loadEmployerData = async () => {
        try {
            const employerDataRes = await fetchGetData('/employer/get/employer/all');
            setEmployerData(employerDataRes.data);
        } catch (error) {
            console.error('Error loading employer data:', error);
            setErrorMessage('Could not load employer data');
        }
    };
    

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [districtRes, jobEmployer] = await Promise.all([
                    fetchGetData('/master/get/district/city'),
                    fetchGetData('/master/get/executive')
                ]);
                setDistricts(districtRes.data);
                setEmployer(jobEmployer.data);
                await loadEmployerData(); // Load employer data separately
            } catch (error) {
                console.error('Error fetching data:', error);
                setErrorMessage('Error loading data');
            }
        };
    
        fetchData();
    }, []);
    

    const handleDistrictChange = (e) => {
        const selectedDistrictId = e.target.value;
        setDistrict(selectedDistrictId);
        setAreas(''); // Reset selected area

        // Find the selected district from the districts array
        const selectedDistrict = districts.find(d => d.id === Number(selectedDistrictId));

        // If district is found, set its areas
        if (selectedDistrict) {
            setAreas(selectedDistrict.areas); // Set areas from the selected district
        } else {
            setAreas([]); // Reset areas if no district is selected
        }
    };
    // const handleGSTINInput = async (e) => {
    //     const companyGSTIN = e.target.value;
    //     const companyGSTINLength = companyGSTIN.length;
    //     console.log(companyGSTIN, companyGSTINLength)
    //     if (e.key === 'Backspace' || e.key === 'Delete') {
    //         setCompanyName('')
    //         setContactName('')
    //         setCompanyAddress('')
    //         setDistrict('')
    //         setSelectedArea('')
    //         setCompanyPincode('')

    //         setDistrict('');
    //         setAreas([]);
    //         setSelectedArea('');
    //     }
    // };


    const handleGSTINInput = async (e) => {
        const gstinValue = e.target.value;
        
        if (gstinValue.trim() === '') {
            setCompanyName('');
            setContactName('');
            setCompanyAddress('');
            setDistrict('');
            setSelectedArea('');
            setCompanyPincode('');
            setAreas([]);
        }
    };
    
    const handleGSTINBlur = async (e) => {
        const companyGSTIN = e.target.value;
        const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        if (e.key === 'Enter' && !loading) {
            e.preventDefault();
            if (!companyGSTIN) {
                alert('Enter valid GSTIN');
                return false;
            }
            setLoading(true)
            // alert(companyGSTIN)
            setCompanyName('')
            setContactName('')
            setCompanyAddress('')
            setDistrict('')
            setSelectedArea('')
            setCompanyPincode('')

            setDistrict('');
            setAreas([]);
            setSelectedArea('');

            if (gstinRegex.test(companyGSTIN)) {
                try {
                    // Construct the API URL with the GSTIN parameter in the query string
                    // const apiUrl = `https://sheet.gstincheck.co.in/check/4e3115f7969022c8a76ab66c6f45c799/${companyGSTIN}`;
                    //
                    // const response = await fetch(apiUrl, {
                    //     method: 'GET', // Specify the GET method
                    //     headers: {
                    //         'Content-Type': 'application/json',
                    //     },
                    // });

                    const apiUrl = "https://api.attestr.com/api/v2/public/corpx/gstin";

                    const response = await fetch(apiUrl, {
                        method: 'POST', // Specify the POST method
                        body: JSON.stringify({
                            'gstin': companyGSTIN,
                            'fetchFilings': false,
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': "Basic T1gwN2UzYTg2ZkJSMHFvTUpGLmJjMzUzMWYwNjg2ZmQ3YzUyMzg3ZDJlZTA2ZWI3MGMwOjNlZDVkMzRjNzBjMGMyMWUyNjhlNDVkZDQ1NmQ1ODhiY2UwNmNkOGRhMDgzNWJjYw==",
                        },
                    });
                    if (response.ok) {
                        const data = await response.json();
                        // console.log('GSTIN validation successful:', data);
                        const getGSTINData = data
                        if (getGSTINData.valid || true) { // data.sts == 'Active'
                            setCompanyName(getGSTINData.tradeName)
                            setContactName(getGSTINData.legalName)
                            let getAddressFromGSTIN = [
                                getGSTINData.addresses[0].building,
                                getGSTINData.addresses[0].buildingName,
                                getGSTINData.addresses[0].floor,
                                getGSTINData.addresses[0].street,
                                getGSTINData.addresses[0].locality,
                                getGSTINData.addresses[0].district,
                                getGSTINData.addresses[0].state
                            ];

// Remove empty values and duplicates
                            let uniqueAddress = [...new Set(getAddressFromGSTIN.filter(Boolean))];

// Append ZIP code
                            setCompanyAddress(uniqueAddress.join(", ") + " - " + getGSTINData.addresses[0].zip);
                            setDistrict(getGSTINData.addresses[0].district)
                            setSelectedArea(getGSTINData.addresses[0].locality)
                            setCompanyPincode(getGSTINData.addresses[0].zip)

                            const options = {
                                includeScore: true,      // Include the match score
                                threshold: 0.3,          // Exact match only (0.0 = exact match)
                                keys: ["dist"],          // Search by the `dist` field in each object
                            };
                            const fuse = new Fuse(districts, options);
                            const selectedDistrictId = handleFindMatch(fuse, getGSTINData.addresses[0].district)
                            setDistrict(selectedDistrictId);
                            setAreas(''); // Reset selected area
                            // Find the selected district from the districts array
                            const selectedDistrict = districts.find(d => d.id === Number(selectedDistrictId));

                            // If district is found, set its areas
                            if (selectedDistrict) {
                                setAreas(selectedDistrict.areas);
                            } else {
                                setAreas([]); // Reset areas if no district is selected
                            }

                            const optionsA = {
                                includeScore: true,      // Include the match score
                                threshold: 0.5,          // Exact match only (0.0 = exact match)
                                keys: ["area_name"],          // Search by the `dist` field in each object
                            };
                            const fuseA = new Fuse(selectedDistrict.areas, optionsA);
                            const selectedArea = handleFindMatch(fuseA, getGSTINData.addresses[0].locality)
                            setSelectedArea(selectedArea);
                        }
                        // Handle success (e.g., show a success message or update the state)
                    } else {
                        console.error('GSTIN validation failed:', response.statusText);
                        // Handle failure (e.g., show an error message)
                    }
                } catch (error) {
                    console.error('Error during API call:', error);
                    // Handle API call error
                } finally {
                    setLoading(false)
                }
            } else {
                console.error('Invalid GSTIN format');
                alert('Invalid GSTIN format');
                // Handle invalid input (e.g., show a validation message)
                setLoading(false)
            }
        }
    };
    const validateForm = () => {
        // if (!companyGSTIN.trim()) return "Company GSTIN is required.";
        if (!companyName.trim()) return "Company name is required.";
        if (!companyMobile.trim()) return "Company mobile is required.";
        if (!companyAddress) return "Address must required.";
        if (!contactName) return "Contact name must required.";
        if (!companyPincode) return "Company pincode must required.";
        if (!district) return "District must be selected.";
        if (!selectedArea) return "Area must be selected.";
        if (!executive) return "Executive must be selected.";
        return null;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const validationError = validateForm();
        if (validationError) {
            setErrorMessage(validationError);
            return;
        }

        // Create a new FormData object and append all form fields to it
        const formData = new FormData();
        formData.append('companyGSTIN', companyGSTIN);
        formData.append('companyName', companyName);
        formData.append('companyMobile', companyMobile);
        formData.append('companyAddress', companyAddress);
        formData.append('contactName', contactName);
        formData.append('companyPincode', companyPincode);
        formData.append('district', district);
        formData.append('selectedArea', selectedArea);
        formData.append('executive', executive);

        setLoading(true);
        try {
            let response;
            if (isEditMode && editEmployerId) {
                // Update request
                formData.append('_id', editEmployerId); // MongoDB document ID
                response = await fetchPostData('/employer/get/employer/update', formData, {
                    'Content-Type': 'application/json',
                });
            } else {
                // Create request
                response = await fetchPostData('/employer/get/employer/create', formData, {
                    'Content-Type': 'application/json',
                });
            }
        
            if (response.success) {
                setSuccessMessage(isEditMode ? 'Employer updated successfully!' : 'Employer created successfully!');
                
                // Refresh employer list
                await loadEmployerData();
            
                // Reset form
                setCompanyGSTIN('');
                setCompanyName('');
                setCompanyMobile('');
                setCompanyAddress('');
                setContactName('');
                setCompanyPincode('');
                setDistrict('');
                setSelectedArea('');
                setExecutive('');
                setIsEditMode(false);
                setEditEmployerId(null);
            }
             else {
                setErrorMessage('Operation failed.');
            }
        } catch (error) {
            console.error('Error submitting the form:', error);
            setErrorMessage(JSON.stringify(error.message));
        }
         finally {
            setLoading(false);
        }

        setTimeout(() => {
            setErrorMessage(''); // Clear error message
            setSuccessMessage(''); // Clear success message
        }, 5000);
    };

    return (
        <div className="container mt-5">
            <Card className="p-4 shadow-sm">
                <h4 className="mb-4">Create employer</h4>
                {loading && (
                    <div className="text-center my-4">
                        <Spinner animation="border"/>
                    </div>
                )}
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="salary">
                                <Form.Label>GSTIN [<small className="text-primary fw-bold">Press Enter after typing the
                                    GSTIN</small> ]</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={companyGSTIN}
                                    onChange={(e) => setCompanyGSTIN(e.target.value)}
                                    // onBlur={handleGSTINBlur}
                                    onKeyDown={handleGSTINBlur}
                                    onKeyUp={handleGSTINInput}
                                    pattern="^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
                                    title="Enter valid GSTIN"
                                    // required
                                    placeholder="Enter GSTIN"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="salary">
                                <Form.Label>Company name <small className="text-danger">*</small></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={companyName}
                                    onChange={(e) => setCompanyName(e.target.value)}
                                    maxLength="255"
                                    title="Enter company name"
                                    required
                                    placeholder="Enter company name"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="salary">
                                <Form.Label>Company mobile <small className="text-danger">*</small></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={companyMobile}
                                    onChange={(e) => setCompanyMobile(e.target.value)}
                                    pattern="^[6789][0-9]{9}$"
                                    title="Enter company mobile"
                                    required
                                    placeholder="Enter company mobile"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="mobile">
                                <Form.Label>Company address <small className="text-danger">*</small></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3} // Number of rows for the textarea
                                    value={companyAddress}
                                    onChange={(e) => setCompanyAddress(e.target.value)}
                                    required
                                    placeholder="Enter company address"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="salary">
                                <Form.Label>Contact name <small className="text-danger">*</small></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={contactName}
                                    onChange={(e) => setContactName(e.target.value)}
                                    maxLength="80"
                                    title="Enter contact name"
                                    required
                                    placeholder="Enter contact name"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="pincode">
                                <Form.Label>Pincode <small className="text-danger">*</small></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={companyPincode}
                                    onChange={(e) => setCompanyPincode(e.target.value)}
                                    maxLength="6"
                                    pattern="^[1-9][0-9]{5}$"
                                    title="Enter a valid 6-digit Indian pincode"
                                    required
                                    placeholder="Enter company pincode"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="district">
                                <Form.Label>District <small className="text-danger">*</small></Form.Label>
                                <Form.Select
                                    value={district}
                                    onChange={handleDistrictChange}
                                    required
                                >
                                    <option value="">Select District</option>
                                    {districts.map(district => (
                                        <option key={district.id} value={district.id}>
                                            {district.dist}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="area">
                                <Form.Label>Area <small className="text-danger">*</small></Form.Label>
                                <Form.Select
                                    value={selectedArea}
                                    onChange={(e) => setSelectedArea(e.target.value)}
                                    required
                                >
                                    <option value="">Select Area</option>
                                    {areas.map(area => (
                                        <option key={area.id} value={area.id}>
                                            {area.area_name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="companyName">
                                <Form.Label>Executive <small className="text-danger">*</small></Form.Label>
                                <Form.Select
                                    value={executive}
                                    onChange={(e) => setExecutive(e.target.value)}
                                    required
                                >
                                    <option value="">Choose executive</option>
                                    {jobEmployer.map(role => (
                                        <option key={role.id} value={role.id}>
                                            {role.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="text-end">
                        {/* <Button type="submit" variant="primary" disabled={loading} onClick={(e) => {
                            if (!window.confirm('Are you sure you want to submit?')) {
                                e.preventDefault(); // Prevent form submission if the user cancels
                            }
                        }}>
                            {loading ? 'Submitting...' : 'Submit'}
                        </Button> */}

<Button type="submit" variant="primary" disabled={loading}>
    {loading ? (isEditMode ? 'Updating...' : 'Submitting...') : (isEditMode ? 'Update' : 'Submit')}
</Button>

                    </div>
                </Form>
           
                {errorMessage && (
                    <Alert variant="danger" className="mt-3">
                        {errorMessage}
                    </Alert>
                )}
                {successMessage && (
                    <Alert variant="success" className="mt-3">
                        {successMessage}
                    </Alert>
                )}
            </Card>
            <div style={{ marginTop:'15px' , padding: '19px', width: '100%',height: 450 }}> {/* Adjust the padding value as needed */}
  <AgGridReact
    rowData={employerData}
    columnDefs={columnsStaffing}
    domLayout="autoHeight"
    loading={loading}
    pagination={true}
    editable={true}
    paginationPageSize={10}
                                            modules={[ValidationModule, ClientSideRowModelModule]}
  />
</div>
        </div>
    );
};

export default TrackEmployee;
